<div class="card">
  <div class="container card-header bg-white">
    <div class="row">
      <div class="col pe-0 my-auto">
        <h6 class="m-1">Business Pants</h6>
      </div>
      <div class="col text-end my-auto">
        <button
          type="button"
          class="btn btn-outline-primary border-0"
          (click)="playAll()">
          <ng-container *ngIf="state.playing; else showPlayButton">
            <i class="bi bi-pause-circle"></i> Pause</ng-container
          >
          <ng-template #showPlayButton>
            <i class="bi bi-play-circle"></i>
            {{ state.paused ? 'Continue' : 'Play All' }}
          </ng-template>
        </button>
      </div>
    </div>
  </div>
  <div class="card-body p-0">
    <cdk-virtual-scroll-viewport [itemSize]="15 * 5" class="podcast-viewport" *ngIf="podcasts$ | async as podcasts" (scrolledIndexChange)="scrolledPodcast($event)">
      <div
        class="list-group border-0"
        *cdkVirtualFor="
          let podcast of podcasts;
          let index = index;
          let count = count;
          let first = first;
          let last = last;
          let even = even;
          let odd = odd
        "
        [class.example-alternate]="odd">
        <a href="#"
          (click)="playPodcast(podcast)"
          class="list-group-item list-group-item-action border-0 rounded-0 pe-0"
          [ngClass]="{ active: state.currentPodcast?.id === podcast.id }"
          aria-current="true">
          <div class="d-flex w-100">
            <div class="p-0 my-auto">
              <img
                src="{{ podcast.artwork }}"
                class="playlist-img"
                draggable="false" />
            </div>
            <div class="p-1 pe-0 mt-auto mb-0 small z-1">
              <p class="m-0 playlist-title">{{ podcast.title }}</p>
              <p class="m-0 text-muted playlist-description">
                <span>{{podcast.published_at | date: 'mediumDate'}}</span><span> · </span>
                <a [href]="podcast.link" target="_blank" class="podcast-link">{{podcast.album}}</a>
              </p>
            </div>

            <div
              class="p-0 z-0"
              style="
                position: absolute;
                text-align: right;
                width: 100%;
                margin-left: -20px;
              ">
              <h1 class="m-0 display-3 index">{{ index + 1 }}</h1>
            </div>
          </div>
        </a>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</div>
